export const TWO_HOURS_IN_SECONDS = 7200;
export const CET_10_AM_TIME = 'T10:00:00+01:00';
export const METRO_AREA_REMOTE = 'Remote';
